import { render, staticRenderFns } from "./defaultPage.vue?vue&type=template&id=7df81b48&scoped=true"
import script from "./defaultPage.vue?vue&type=script&lang=js"
export * from "./defaultPage.vue?vue&type=script&lang=js"
import style0 from "./defaultPage.vue?vue&type=style&index=0&id=7df81b48&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df81b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df81b48')) {
      api.createRecord('7df81b48', component.options)
    } else {
      api.reload('7df81b48', component.options)
    }
    module.hot.accept("./defaultPage.vue?vue&type=template&id=7df81b48&scoped=true", function () {
      api.rerender('7df81b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/defaultPage.vue"
export default component.exports